import {Component} from 'react'
import {observer, inject} from 'mobx-react'

//inspired by: https://medium.com/the-many/adding-login-and-authentication-sections-to-your-react-or-react-native-app-7767fd251bd1
class EnsureLoggedInContainer extends Component {
    componentDidMount() {
        const { stores, location } = this.props
        const { store, authStore, routingStore } = stores
        const { replace } = routingStore

        if (!authStore.authUser()) {
            // set the current url/path for future redirection
            store.redirectUrl = location.pathname
            // then redirect (we use a React Router method)
            replace("/signup")
        }
    }

    render() {
        const { authStore } = this.props.stores

        if (authStore.authUser()) {
            return this.props.children
        } else {
            return null
        }
    }
}

export default inject("stores")(observer(EnsureLoggedInContainer))



// WEBPACK FOOTER //
// ./src/containers/EnsureLoggedInContainer.js